<template>
  <div class="filters">
    <div class="filters__box">
      <header class="filters__box__header">
        <div class="filters__box__header__title">
          {{ $t('filters.title') }}
        </div>
        <ui-button
          class="filters__box__header__close"
          @click.stop="resetFilters"
          button="secondary"
          :label="$t('filters.reset.tooltip')"
          :icon-only="true"
          icon="reset"
          v-tooltip="{
            placement: 'top',
            trigger: 'hover click',
            content: $t('filters.reset.tooltip'),
            offset: 3,
          }"
        >
        </ui-button>
      </header>
      <div class="filters__box__container">
        <div class="filters__box__container__no-data" v-if="!currentUseCase">
          {{ $t('noData.noUseCase') }}
        </div>
        <template v-else>
          <div class="filters__box__container__sub-filter">
            <div class="filters__box__container__sub-filter__title">
              <div class="filters__box__container__sub-filter__title__text">
                {{ $t('filters.registre.title') }}
                <span
                  class="backoffice-icons filters__box__container__sub-filter__title__text__icon"
                  v-tooltip="{
                    placement: 'top',
                    trigger: 'hover click',
                    content: $t('filters.registre.tooltip'),
                    offset: 3,
                  }"
                >
                  info
                </span>
              </div>
            </div>
            <ui-dropdown
              id="review-registre"
              v-model="registre"
              :options="registreOptions"
              :placeholder="$t('filters.registre.placeholder')"
              label="name"
              track-by="id"
            />
          </div>
          <div class="filters__box__container__sub-filter">
            <div class="filters__box__container__sub-filter__title">
              <div class="filters__box__container__sub-filter__title__text">
                {{ $t('filters.signature.title') }}
                <span
                  class="backoffice-icons filters__box__container__sub-filter__title__text__icon"
                  v-tooltip="{
                    placement: 'top',
                    trigger: 'hover click',
                    content: $t('filters.signature.tooltip'),
                    offset: 3,
                  }"
                >
                  info
                </span>
              </div>
              <ui-switch id="review-signature-toggle" v-model="hasSignature" :standalone="true"></ui-switch>
            </div>
            <ui-input
              id="review-signature"
              :label="$t('filters.signature.placeholder')"
              v-model="signature"
              :disabled="!isSignatureActive"
              :hide-label="true"
            />
          </div>
          <div class="filters__box__container__sub-filter">
            <div class="filters__box__container__sub-filter__title">
              <div class="filters__box__container__sub-filter__title__text">
                {{ $t('filters.promotion.title') }}
                <span
                  class="backoffice-icons filters__box__container__sub-filter__title__text__icon"
                  v-tooltip="{
                    placement: 'top',
                    trigger: 'hover click',
                    content: $t('filters.promotion.tooltip'),
                    offset: 3,
                  }"
                >
                  info
                </span>
              </div>
              <ui-switch id="review-promo-toggle" v-model="hasPromotion" :standalone="true"></ui-switch>
            </div>
            <ui-input
              id="review-promo"
              :label="$t('filters.promotion.placeholder')"
              v-model="promotion"
              :disabled="!isPromotionActive"
              :hide-label="true"
            />
          </div>
          <div class="filters__box__container__sub-filter">
            <div class="filters__box__container__sub-filter__title">
              <div class="filters__box__container__sub-filter__title__text">
                {{ $t('filters.promotionDate.title') }}
                <span
                  class="backoffice-icons filters__box__container__sub-filter__title__text__icon"
                  v-tooltip="{
                    placement: 'top',
                    trigger: 'hover click',
                    content: $t('filters.promotionDate.tooltip'),
                    offset: 3,
                  }"
                >
                  info
                </span>
              </div>
            </div>
            <ui-date-picker
              id="review-promo-date"
              v-model="dateRange"
              :label="$t('filters.promotionDate.placeholder')"
              mode="range"
              :disabled="!isPromotionActive"
              :hide-label="true"
            />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import UiSwitch from '@/components/UI/Switch.vue'
import UiInput from '@/components/UI/Input.vue'
import UiDropdown from '@/components/UI/Dropdown.vue'
import UiDatePicker from '@/components/UI/DatePicker.vue'
import UiButton from '@/components/UI/Button.vue'

export default {
  name: 'Filters',
  components: {
    UiSwitch,
    UiInput,
    UiDropdown,
    UiDatePicker,
    UiButton,
  },
  data() {
    return {
      registreOptions: [
        { name: this.$t('filters.registreOptions.formel'), id: 'formel', key: 0 },
        { name: this.$t('filters.registreOptions.common'), id: 'common', key: 1 },
        { name: this.$t('filters.registreOptions.familiar'), id: 'familiar', key: 2 },
      ],
    }
  },
  computed: {
    ...mapState({
      currentUseCase: state => state.data.currentUseCase,
      currentRegistre: state => state.refine.currentRegistre,
      currentSignature: state => state.refine.currentSignature,
      currentPromotion: state => state.refine.currentPromotion,
      currentPromotionDateRange: state => state.refine.currentPromotionDateRange,
      isSignatureActive: state => state.refine.isSignatureActive,
      isPromotionActive: state => state.refine.isPromotionActive,
    }),
    registre: {
      get() {
        return this.currentRegistre
      },
      set(registre) {
        this.updateCurrentRegistre(registre)
      },
    },
    signature: {
      get() {
        return this.currentSignature
      },
      set(signature) {
        this.updateCurrentSignature(signature)
      },
    },
    promotion: {
      get() {
        return this.currentPromotion
      },
      set(promo) {
        this.updateCurrentPromotion(promo)
      },
    },
    dateRange: {
      get() {
        return this.currentPromotionDateRange
      },
      set(rangeDate) {
        this.updateCurrentPromotionDateRange(rangeDate)
      },
    },
    hasSignature: {
      get() {
        return this.isSignatureActive
      },
      set(boolean) {
        this.updateIsSignatureActive(boolean)
      },
    },
    hasPromotion: {
      get() {
        return this.isPromotionActive
      },
      set(boolean) {
        this.updateIsPromotionActive(boolean)
      },
    },
  },
  methods: {
    ...mapActions({
      updateCurrentRegistre: 'refine/updateCurrentRegistre',
      updateCurrentSignature: 'refine/updateCurrentSignature',
      updateCurrentPromotion: 'refine/updateCurrentPromotion',
      updateCurrentPromotionDateRange: 'refine/updateCurrentPromotionDateRange',
      updateIsSignatureActive: 'refine/updateIsSignatureActive',
      updateIsPromotionActive: 'refine/updateIsPromotionActive',
      resetFilters: 'refine/resetFilters',
    }),
  },
}
</script>

<style lang="scss" scoped>
.filters {
  width: 100%;

  @media (min-width: $screen-sm) {
    height: calc(50% - #{$gutter-md / 2});
  }

  &__box {
    @include box;

    @media (min-width: $screen-sm) {
      height: 100%;
    }

    &__header {
      @include header;

      &__close {
        @include close;
      }

      &__title {
        @include title;
      }
    }

    &__container {
      @include container;

      &__no-data {
        @include noData;
      }

      &__sub-filter {
        margin-top: $spacing-md;

        &:first-child {
          margin-top: 0;
        }

        &__title {
          @include sub-title;

          display: flex;
          align-items: center;
          justify-content: space-between;

          &__text {
            display: flex;
            align-items: center;

            &__icon {
              margin-left: 12px;
              font-size: $font-size-title;
            }
          }
        }
      }
    }
  }
}
</style>
